import { Type } from "class-transformer";
import { IsArray, IsDate, ValidateNested } from "class-validator";
import TransmedRegistrationRank from "./registrationRank";

export default class TransmedRanking {
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => TransmedRegistrationRank)
  public readonly ranking!: TransmedRegistrationRank[];

  @Type(() => Date)
  @IsDate()
  public readonly contesting_deadline!: Date;

  @Type(() => Date)
  @IsDate()
  public readonly points_deadline_second!: Date;
}
